import type { Point } from '@/types'

export function getSVGPoint(svg: SVGSVGElement, event: MouseEvent): Point {
  const point = svg.createSVGPoint()
  point.x = event.clientX
  point.y = event.clientY
  const transformed = point.matrixTransform(svg.getScreenCTM()!.inverse())
  return { x: transformed.x, y: transformed.y }
}

export function isInsideCookie(point: Point): boolean {
  return point.x >= 0 && point.x <= 200 && point.y >= 0 && point.y <= 200
}

export function vibrate(intensity: number): void {
  if (!navigator.vibrate) return
  
  // Progressive vibration patterns - each tap gets more intense
  const patterns = [
    [20],           // Tap 1: Light single pulse
    [25, 50, 30],   // Tap 2: Double pulse with pause
    [35, 40, 35, 40, 40], // Tap 3: Triple pulse building tension
    [50, 30, 50, 30, 60]  // Tap 4: Strong pattern for final crack
  ]
  
  const pattern = patterns[Math.min(intensity - 1, 3)] || [20]
  navigator.vibrate(pattern)
}

export function vibrateBreak(): void {
  if (!navigator.vibrate) return
  
  // Special satisfying break vibration - strong burst followed by gentle fade
  navigator.vibrate([80, 50, 60, 50, 40])
}

export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    // Fallback for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }
}
